import {
    SHARE
} from "../../constants/ActionTypes";

export const share = (shareData) => {
    return {
        type: SHARE,
        payload: shareData
    }
}
